import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "form__field-set" };
const _hoisted_2 = { class: "form__group" };
const _hoisted_3 = { class: "form__label-wrapper" };
const _hoisted_4 = {
    class: "form__label",
    for: "cart-customer-order-number"
};
const _hoisted_5 = { class: "form__control-wrapper" };
const _hoisted_6 = ["maxlength"];
import { ref } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CartCustomerOrderNumber',
    props: {
        order: {},
        maxLength: {}
    },
    emits: [
        'change'
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const number = ref(props.order.customerOrderNumber || '');
        function onChange() {
            emit('change', number.value && number.value.trim());
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", {
                class: "form form--simple cart-customer-order-number",
                onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => { }, ["prevent"]))
            }, [
                _createElementVNode("fieldset", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('order.customer_order_number')), 1)
                        ]),
                        _cache[2] || (_cache[2] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_5, [
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                id: "cart-customer-order-number",
                                class: "form__control cart-customer-order-number__input",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((number).value = $event)),
                                onChange: onChange,
                                maxlength: __props.maxLength
                            }, null, 40, _hoisted_6), [
                                [_vModelText, number.value]
                            ])
                        ])
                    ])
                ])
            ], 32));
        };
    }
});
